<template>
    <div
        class="spacer-root"
        :style="{
            '--marginSmall': `${spacingSmall}px`,
            '--marginNormal': `${spacingNormal}px`,
        }"
    >
        <div
            class="spacer-content"
            :style="{
                maxWidth: props.contentMax
                    ? `${props.contentMax}px`
                    : undefined,
            }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, inject } from "vue";
import { useDeviceKind } from "@/composables/use-device-kind";
import { useDevicePreferencesStore } from "@/store/device-preferences-store";
import { storeToRefs } from "pinia";
import { refProp } from "@/composables/reactive";

const devicePrefsStore = useDevicePreferencesStore();
const { preferences } = storeToRefs(devicePrefsStore);
const ui = refProp(preferences, "ui");

const deviceKind = useDeviceKind();

const props = withDefaults(
    defineProps<{
        contentMax?: number | null;
        marginMin?: number;
        marginMax?: number;
    }>(),
    {
        contentMax: null,
        marginMin: 12,
        marginMax: 24,
    },
);

const shouldSpacerMin = inject("shouldSpacerMin", false);

const spacingSmall = computed(() => {
    if (ui.value === "classic") {
        return 12;
    }

    return props.marginMin;
});

const spacingNormal = computed(() => {
    if (
        ui.value === "classic" ||
        shouldSpacerMin ||
        deviceKind.value === "smartphone"
    ) {
        return spacingSmall.value;
    }

    return props.marginMax;
});
</script>

<style lang="scss" scoped>
.spacer-root {
    box-sizing: border-box;
    width: 100%;
    container-type: inline-size;

    .spacer-content {
        margin: 0 auto;
        padding: var(--marginSmall);

        @media (min-width: 400px) {
            @container (width > 360px) {
                padding: var(--marginNormal);
            }
        }
    }
}
</style>
